Pixlee.module('Tap2ShopApp.Show', function(Show, App, Backbone, Marionette, $) {

    Show.Layout = App.Views.Layout.extend({
        template: require('./templates/layout.jst.ejs'),
        regions: {
            frame: '.tap2shop_frame'
        },
        collectionEvents: {
            'sync': function() {
                if (!this.collection.next) {
                    this.$el.find('.load_more').hide();
                }
            }
        },
        events: {
            'click .load_more': function() {
                this.$el.find('.load_more').addClass('loading');
                var _this = this;
                this.collection.nextPage({
                    success: function() {
                        _this.$el.find('.load_more').removeClass('loading');
                        App.commands.execute('load:more', _this.collection.pluck('album_photo_id'));
                        if (!_this.collection.next) {
                            _this.$el.find('.load_more').hide();
                        }
                    }
                });
            },
            // prevents <a> with role 'button' to open a new window when href = '#'
            'click .custom_call_to_action_anchor': function(ev) {
                ev.preventDefault();
            }
        }
    });
    Show.PhotoView = App.Views.ItemView.extend({
        template: require('../../common/templates/v2/_tap2shop_photo_item.jst.ejs'),
        className: 'tap2shop_photo_block',
        tagName: 'li',
        behaviors: {
            Reviews: {},
            Lightbox: {},
            UpdateThumbnailCss: {}
        },
        initialize: function() {
            if (this.model.get('is_starred')) {
                this.$el.addClass('starred');
            }
        },
        templateHelpers: {
            tap2shop_thumbnail_size: 'xl',
            decodeUtf8: function(string) {
                return App.request('decode:utf8', string);
            },
            ctaTarget: function() {
                return gon.display_options.ctaCurrentTab ? '_parent' : '_blank';
            },
             // getCustomCallToActionLink() should always open a lightbox so cta link would not matter here.
            getCustomCallToActionLink: function() {
                return '#';
            },
             // photoItemRole() should always open a lightbox meaning <a> should have a button role.
            photoItemRole: function() {
                return 'button';
            },
            contentType: function() {
                // string corresponds to the variable in the en.yml
                return this.isVideo() ? 'photo_item.open_video' : 'photo_item.open_photo';
             },
            hasReview: function() {
                var reviewOptions = gon.display_options.reviewOptions;
                return reviewOptions && reviewOptions.displayReviews && this.getReview().id !== '0';
            }
        }
    });
    Show.PhotoView.include(['PhotoViewHelpers', 'ReviewHelpers', 'AccessibilityHelpers', 'socialShareHelpers']);

    // Photowall View
    Show.PhotowallCollection = App.Views.CollectionView.extend({
        childView: Show.PhotoView,
        className: 'clearfix',
        tagName: 'ul',
        initialize: function() {
            this.collection.reviewSelectionOptions = {
                currentModelIndex: 0
            };
        },
        onShow: function() {
            $('#widget').attr('alt', App.altText);
        }
    });

});
